import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Skeleton from '@mui/material/Skeleton';

export const ListSkeletonLoader = ({ items = 5 }: { items?: number }) => {
  return (
    <List dense disablePadding>
      <Box
        sx={{
          p: 2,
        }}
      >
        {Array.from({ length: items }).map((_, index) => (
          <Skeleton key={index} />
        ))}
      </Box>
    </List>
  );
};
